import ApiService from '@/services/api.service';
import TokenService from './token.service';
import { ParticipantDTO } from '@/models/ParticipantDTO';
import { IdentificationDTO } from '@/models/IdentificationDTO';
import { PUBLIC_ROOT_API } from '@/config/app.config';
import { ActionTypes, GetterTypes, MutationTypes } from '@/store-vuex/types';
import router from '@/router';
import LocalStoreService from '@/store/local.store';
import { AppointmentDetailsDTO } from '@/models/AppointmentDetailsDTO';
import { AxiosResponse } from 'axios';
import { mutations } from '@/store/store';


export default class ParticipantService {

  /**
   * Login the participant
   *
   * @returns {IdentificationDTO} A DTO object containing su route prefix
   */
  public static async login(partId: number, dateOfBirth: string, suRoutePrefix: string) {
    const requestData = {
      method: 'post',
      url: `${PUBLIC_ROOT_API}/rdv/participants/identify`,
      data: {
        partId,
        dateOfBirth,
        suRoutePrefix,
      },

    };

    return await ApiService.post(requestData.url, requestData.data)
      .then((response: any) => {
        const identficationData = response.data as IdentificationDTO;
        return identficationData;
      });

  }

  /**
   * Logout the current participant by calling the API in order to expire the cookies.
   * It also removes the JWT token from storage and XSRF token from header.
   */
  public static async logout() {
    const requestData = {
      url: `${PUBLIC_ROOT_API}/rdv/Participants/logout`,
    };

    await ApiService.post(requestData.url, {})
      .then((response: any) => {
        // Remove the token and remove Authorization header from Api Service as well
        this.logoutFromFrontend();
      });
  }

  /**
   * Logout the current participant by removing the JWT token from storage and XSRF token from header.
   * clear the store
   */
  public static logoutFromFrontend() {
    TokenService.removeToken();
    ApiService.removeHeader(TokenService.X_XSRF_TOKEN);
    mutations.setIsIdentified(false);
  }

  /**
   * Fetch the administrative data from PublicInclusionContent if any.
   * Otherwise fetch the actual administrative data.
   *
   * @returns {ParticipantDTO} A DTO object representing the participant
   */
  public static async fetchParticipant(partId: number) {
    return await ApiService.get(`${PUBLIC_ROOT_API}/rdv/Participants/${partId}`)
      .then((response: any) => {
        return response.data as ParticipantDTO;
      });
  }

  /**
   * Check if it's the first rdv
   * @returns {boolean} true if it's the first rdv
   */
   public static async isFirstApt(partId: number) {
    return await ApiService.get(`${PUBLIC_ROOT_API}/rdv/Appointment/${partId}/first-appointment`)
      .then((response: AxiosResponse) => {
        return response.data as boolean;
      });
  }


  public static async postAppointDetails(appointDetails: AppointmentDetailsDTO) {
    await ApiService.post(`${PUBLIC_ROOT_API}/rdv/Participants/AddappointDetails`,
      appointDetails)
      // tslint:disable-next-line: no-empty
      .then((response: any) => { });
  }
}
